import { render, staticRenderFns } from "./user_outdoors_placard_media.vue?vue&type=template&id=2504aaea&scoped=true"
import script from "./user_outdoors_placard_media.vue?vue&type=script&lang=js"
export * from "./user_outdoors_placard_media.vue?vue&type=script&lang=js"
import style0 from "./user_outdoors_placard_media.vue?vue&type=style&index=0&id=2504aaea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504aaea",
  null
  
)

export default component.exports